import { deleteCategoriesTasks, getCategoriesTasks } from "../components/api";
import { CategoriesTasksEditForm, CategoriesTasksTableRow } from "../components";
import { $categoriesTasks, setCategoriesTasks } from "../store/cards";
import React, { useState } from 'react';
import { useStore } from 'effector-react';
import {
    Button,
    TableContainer,
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    Paper,
    Dialog,
    DialogContent,
    DialogContentText,
    DialogActions
} from '@mui/material';

const default_catrgory_value = {
    id: null,
    bitrix_code: '',
    name: '',
    default_volume: 0
}

export function CategoriesTasksPage() {
    const categoriesTasks = useStore($categoriesTasks);
    const [showEditForm, setShowEditForm] = useState(false);
    const [editedCategory, setEditedCategory] = useState(null);
    const [showDialogDelete, setShowDialogDelete] = useState(false);

    React.useEffect(() => {
        getCategoriesTasks().then(data => setCategoriesTasks(data));
    }, [categoriesTasks.length]);

    const addCategory = () => {
        setEditedCategory(default_catrgory_value);
        setShowEditForm(true);
    };

    const handleCloseDialog = (event, dialogResult) => {
        if (dialogResult) {
            deleteCategoriesTasks(editedCategory.id).then(_ => getCategoriesTasks().then(data => setCategoriesTasks(data)));
        }
        setShowDialogDelete(false);
    };

    const closeEditForm = (editResult) => {
        setShowEditForm(false);
        if(editResult) getCategoriesTasks().then(data => setCategoriesTasks(data));
    }

    return (
        <div>
            <Button variant="contained" onClick={addCategory}>Добавить</Button>
            <div style={{ width: 1000 }}>
                <TableContainer component={Paper} id="tasks-table">
                    <Table sx={{ minWidth: 650 }} size="small" aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                <TableCell width={300}><b>Наименование</b></TableCell>
                                <TableCell><b>Id Bitrix</b></TableCell>
                                <TableCell><b>Объём по умолчанию</b></TableCell>
                                <TableCell><b>Действия</b></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {categoriesTasks.map(category =>
                                <CategoriesTasksTableRow
                                    key={category.id}
                                    category={category}
                                    setShowEditForm={setShowEditForm}
                                    setEditedCategory={setEditedCategory}
                                    setShowDialogDelete={setShowDialogDelete}
                                />)}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
            {showEditForm ? <CategoriesTasksEditForm closeEditForm={closeEditForm} category={editedCategory} /> : null}
            <Dialog
                open={showDialogDelete}
                onClose={handleCloseDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Вы уверенны, что хотите удалить категорию?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={(event) => handleCloseDialog(event, true)} color="primary">
                        Да
                    </Button>
                    <Button onClick={(event) => handleCloseDialog(event, false)} color="primary" autoFocus>
                        Нет
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}